export default __webpack_public_path__ + "static/media/superhost-subscription.92741b4f.svg";